import { useState } from "react";
import { Drawer, Button, Card, Header, Text, Icons } from "../../design";
import { EVENT_TYPES } from "../../utils/constants";
import { emitCustomEvent, handleError, useAxios } from "../../utils/helpers";
import { translate, translateLocalizedEntity } from "../../utils/translations";
import { useContract } from "../contract-provider";
import { useLoop } from "../loop-provider";
import { useLoyalty } from "../loyalty-provider";
import { useLoopAuth } from "../auth-provider";

function LoyaltyDiscountCard({ discountCode, title }) {
    const [axios] = useAxios();
    const { loadDataFriendbuy } = useLoyalty();
    const { storeId } = useLoopAuth();
    const { preferences } = useLoop();
    const contractCtx = useContract();

    const [isCopied, setisCopied] = useState(false);
    const [isDiscountApplying, setisDiscountApplying] = useState(false);

    const copyCode = () => {
        navigator.clipboard.writeText(discountCode);
        setisCopied(true);
        setTimeout(() => {
            setisCopied(false);
        }, 1000);
    };

    const applyDiscount = async () => {
        setisDiscountApplying(true);
        try {
            const body = {
                subscriptionContract_shopify_id: contractCtx.contract.shopify_id,
                discountCode: discountCode,
            };
            const { data }: any = await axios.post(
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/add_discount_code?`,
                body,
            );
            if (data?.success) emitCustomEvent(EVENT_TYPES.ADD_DISCOUNT);
            await loadDataFriendbuy();
            contractCtx.displayActionMessage(translate(data.messageKey, data.placeholders), data.success);
        } catch (error) {
            handleError(error, "components/cards/discounts", "handleConfirm", {
                subscriptionContract_shopify_id: contractCtx.contract.shopify_id,
                discountCode: discountCode,
                repsonse: error.response?.data,
            });
        }
        setisDiscountApplying(false);
    };

    return (
        <Card className="mx-1 my-2">
            <Card.Body className="d-flex align-items-center">
                <div className="flex-fill">
                    <div className="d-flex">
                        <Text.P1>{discountCode}</Text.P1>
                        <Button variant="underline" className="ms-3" onClick={copyCode}>
                            {isCopied ? <Icons.Tick color="black" /> : <Icons.Copy />}
                        </Button>
                    </div>
                    {title && <Text.P2 className="loop-text-muted">{title}</Text.P2>}
                </div>
                <div>
                    {contractCtx?.contract &&
                        !!(
                            preferences.cp_subscription_apply_discount === 1 && !contractCtx?.cancelledPausedOrExpired
                        ) && (
                            <Button onClick={applyDiscount}>
                                {isDiscountApplying ? (
                                    <Icons.Spinner size="sm" />
                                ) : (
                                    translateLocalizedEntity(
                                        "CP_THEME_ADVENT_LOYALTY_FB",
                                        storeId,
                                        "loyalty_discounts_drawer_apply_btn_fb",
                                        translate("loyalty_discounts_drawer_apply_btn_fb"),
                                    )
                                )}
                            </Button>
                        )}
                </div>
            </Card.Body>
        </Card>
    );
}

function LoyaltyDiscountsDrawerFriendbuy(props: any) {
    const { friendbuyData } = useLoyalty();
    const { storeId } = useLoopAuth();
    return (
        <Drawer
            title={translateLocalizedEntity(
                "CP_THEME_ADVENT_LOYALTY_FB",
                storeId,
                "loyalty_discounts_drawer_header_fb",
                translate("loyalty_discounts_drawer_header_fb"),
            )}
            active={props.active}
            toggleActive={props.toggleActive}
            id="loyalty-discounts"
        >
            <Drawer.Body className="pt-0">
                <Header.H3 className="mx-1 my-2">
                    {translateLocalizedEntity(
                        "CP_THEME_ADVENT_LOYALTY_FB",
                        storeId,
                        "loyalty_discounts_available_coupons_text_fb",
                        translate("loyalty_discounts_available_coupons_text_fb"),
                        {
                            coupons: friendbuyData.couponCount,
                        },
                    )}
                </Header.H3>
                {friendbuyData.couponsList.map((item, i) => {
                    return (
                        <LoyaltyDiscountCard
                            discountCode={item.couponCode}
                            title={item?.title || "Discount code"}
                            key={i}
                        />
                    );
                })}
            </Drawer.Body>
            <Drawer.Footer>
                <div className="d-flex flex-column">
                    <Button size="lg" variant="underline" className="m-2" onClick={props.toggleActive}>
                        {translateLocalizedEntity(
                            "CP_THEME_ADVENT_LOYALTY_FB",
                            storeId,
                            "loyalty_discounts_drawer_go_back_btn_fb",
                            translate("loyalty_discounts_drawer_go_back_btn_fb"),
                        )}
                    </Button>
                </div>
            </Drawer.Footer>
        </Drawer>
    );
}

export default LoyaltyDiscountsDrawerFriendbuy;
